<template>
  <modal :show="show" showLarge>
    <div slot="modalHeader">
      <modal-header :closeModal="closeModal">{{modalHeadVal}}</modal-header>
    </div>
    <spinner-icon v-if="loading" />
    <div v-if="showError" class="text-danger center">
      {{ errorText }}
    </div>
    <div v-if="isAcceptingApproval">
      Are you sure you want to approve downloads for this creative?
      <modal-footer :closeModal="backFromAnything" :confirm="confirmApprove" :confirmText="'Approve'" :back="backFromAnything" :showBack="true" :hideCancelText="true" />
    </div>
    <div v-else-if="isPushingSingle">
      Please confirm push to user's dashboard?
      <modal-footer :closeModal="backFromAnything" :confirm="confirmPushAct" :confirmText="'Push'" :back="backFromAnything" :showBack="true" :hideCancelText="true" />
    </div>
    <div v-else-if="isPushingAll">
      Please confirm push to all users dashboards?
      <modal-footer :closeModal="backFromAnything" :confirm="confirmPushAllAct" :confirmText="'Push'" :back="backFromAnything" :showBack="true" :hideCancelText="true" />
    </div>
    <div v-else-if="!isDeleting && !isAcceptingApproval && !isEditingFields && !isAddingAssignee && !isPushingAll && !isPushingSingle">
      <!-- Start Body -->
      <slot-table :data="getChildCreatives" :columns="table.columns">
          <template slot="name" slot-scope="props">
            <router-link :to="{ path: `/creatives/${props.item.hash_id}/bulk` }">
              {{ props.item.name }}
            </router-link>
          </template>
          <template slot="status" slot-scope="props">
            <span class="text-uppercase label text-center text-capitalize" :class="getStatusClass(props.item.status)">
              {{ props.item.status.replaceAll('_',' ') }}
            </span>
          </template>
          <template slot="user" slot-scope="props">
            <span>{{ props.item.user_name }}</span>
          </template>
          <template slot="downloaded" slot-scope="props">
            <span>{{ props.item.downloads_count }} / {{ props.item.units_count }}</span>
          </template>
          <template slot="updated" slot-scope="props">
            <span>{{ props.item.updated_count }} / {{ props.item.units_count }}</span>
          </template>
          <template slot="date_created" slot-scope="props">
            <span>{{props.item.date_created.value | formatDate }}</span>
          </template>
          <template slot="date_updated" slot-scope="props">
            <span>{{props.item.date_updated.value | formatDate }}</span>
          </template>

          <template slot="creativeActions" slot-scope="props">
                <span v-if="props.item">
                  <button v-if="props.item.status === 'approval_requested'" @click="approveDownloadsAct(props.item.hash_id)" title="approve" class="btn btn-primary btn-xs">
                    Approve
                  </button>
                  <button title="delete" @click="deleteCreativeAct(props.item.hash_id)" class="btn btn-danger btn-xs">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                  <button v-if="!props.item.is_pushed" @click="pushAct(props.item.hash_id)" title="push" class="btn btn-success btn-xs">
                    Push
                  </button>
                  <router-link :to="{ path: `/tags/creative/${props.item.hash_id}` }" class="btn btn-xs btn-info" v-if="props.item.has_tags">
                    <i class="fa fa-tag" aria-hidden="true"></i>
                  </router-link>
                </span>
          </template>
      </slot-table>
      <button v-if="showPushAll" @click="pushAllAct()" style="float: right; padding: 0.7rem;" title="push creatives to all users" class="btn btn-success btn-xs text-capitalize">
        Push creatives to all users
      </button>
      <br>
      <br>
      <div class="d-flex justify-content-around">
        <button v-if="!isAddingAssignee" @click="addAssignee(confirmId)" style="float: right; margin-right: 0.3rem; padding: 0.7rem" title="add new users" class="btn btn-primary btn-xs">
          Add New Users
        </button>
        <button v-if="!isEditingFields" @click="editFields(confirmId)" style="float: right; padding: 0.7rem; margin-right: 0.3rem;" title="edit fields" class="btn btn-primary p-10 btn-xs">
          Edit Fields
        </button>
      </div>
      <!-- End Body -->
    </div>
    <div v-else-if="isEditingFields">
<!--      <form-group>-->
<!--        <field name="Name" :value="creative.name" v-model="form.name"/>-->
<!--      </form-group>-->
      <creative-table :subHeading="`Please select the fields to be edited in this creative`" :tableData="getChildFields" v-model="getChildFields" @onToggleParentCheckboxes="updateCheckboxData" :type="creative.type" />
      <modal-footer :closeModal="backFromAnything" :confirm="confirm" :confirmText="'Save'" :back="backFromAnything" :showBack="true" :hideCancelText="true" />
    </div>
    <div v-else-if="isDeleting">
      Are you sure you want to delete this Creative Association?
      <modal-footer :closeModal="backFromAnything" :confirm="confirmDelete" :confirmText="'Delete'" :back="backFromAnything" :showBack="true" :hideCancelText="true" />
    </div>
    <div v-else-if="isAddingAssignee">
      <heading type="h4">
        <small>{{haveAnyAssignee? "Please select users to receive this creative":"No assignable users found"}}</small>
      </heading>
      <div v-if="haveAnyAssignee">
      <label v-if="haveAnyAssignee && getUsers().length">Global Users</label>
      <small v-else>No Assignable Global Users Found</small>
      <list v-model="userss" :data="getUsers()" :hashId="false" :currentIds="this.userss" />
      <label v-if="haveAnyAssignee && getLocalUsers().length">Local Users</label>
      <small v-else>No Assignable Local Users Found</small>
      <list v-model="localUsers" :data="getLocalUsers()" :hashId="false" :currentIds="this.localUsers" />
      </div>
      <modal-footer :closeModal="backFromAnything" :confirm="confirm" :confirmText="'Save'" :back="backFromAnything" :hideConfirmText="!haveAnyAssignee" :showBack="true" :hideCancelText="true" />
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalFooter from '@/components/Modal/modal-footer'
import ModalHeader from '@/components/Modal/modal-header'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import CreativeTable from '@/components/CreativeTable/creative-table'
import List from '@/components/List/list'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import {modalMixin} from '@/mixins/modalMixin'
import {campaignMixin} from '@/mixins/campaignMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import SlotTable from '@/components/Table/table'
import Heading from '@/components/Heading/heading'
import {userMixin} from '@/mixins/userMixin'
import SpinnerIcon from '@/components/SpinnerIcon/spinner'
import {assoc, find, map, propEq} from 'ramda'

export default {
  name: 'modal_edit_creative_associate',
  mixins: [modalMixin, campaignMixin, creativeMixin, notificationMixin, userMixin],
  components: {
    Checkbox,
    Modal,
    ModalHeader,
    ModalFooter,
    Heading,
    ButtonCta,
    FormGroup,
    Field,
    CreativeTable,
    List,
    SpinnerIcon,
    SlotTable
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String
  },
  data: () => ({
    isDeleting: false,
    isEditingFields: false,
    isAddingAssignee: false,
    isAcceptingApproval: false,
    isPushingSingle: false,
    isPushingAll: false,
    modalHeadVal: 'Edit Associations',
    selectedCreative: null,
    userss: [],
    localUsers: [],
    form: {
      name: '',
      hash_id: '',
      editable_fields: []
    },
    table: {
      columns: {
        name: 'Creative Name',
        user: 'User Name',
        status: 'Status',
        downloaded: 'Downloaded',
        updated: 'Rendered',
        date_created: 'Date Created',
        date_updated: 'Date Updated',
        creativeActions: ''
      }
    },
    showError: false,
    errorText: 'Assigned User cannot be empty'
  }),
  computed: {
    creative () {
      if (this.creatives) {
        const creative = find(propEq('hash_id', this.confirmId), this.creatives)
        if (creative && creative.childs.length > 0) {
          creative.childs[0].fields = map(item => assoc('editableActions', true, item), creative.childs[0].fields)
        }
        return creative
      }
    },
    getChildCreatives () {
      if (this.creative && this.creative.childs.length > 0) {
        return this.creative.childs
      }
    },
    getChildFields () {
      if (this.creative && this.creative.childs.length > 0) {
        return this.creative.childs[0].fields
      }
    },
    haveAnyAssignee () {
      if (this.getUsersToBeAssociated.length) {
        return true
      } else {
        return false
      }
    },
    getUsersToBeAssociated () {
      let cve = Array(this.getChildCreatives)[0]
      const result = Array(this.campaign.client.associatedUsers)[0].filter(item => {
        let res = true
        cve.forEach((el) => {
          if (el.name.search(item.name.replaceAll(' ', '_')) !== -1) {
            res = false
          }
        })
        return res
      })
      return result
    },
    showPushAll () {
      if (!this.creative || !this.creative.childs) {
        return
      }
      let status = false
      this.creative.childs.forEach((child) => {
        if (child.is_pushed === 0) {
          status = true
        }
      })
      return status
    }
  },
  methods: {
    getStatusClass (status) {
      switch (status) {
        case 'approved':
          return 'label-success'
        case 'approval_requested':
          return 'label-warning'
        default:
          return 'label-primary'
      }
    },
    save () {
      this.close()
    },
    closeModal () {
      this.backFromAnything()
      this.close()
    },
    confirmPushAct () {
      this.startLoading()
      this.creativePushAssociations(this.form).then((res) => {
        this.getCreatives(this.$route.params.id).then(() => {
          this.addNotification('success', res.reason)
          this.backFromAnything()
          this.finishLoading()
        })
      }).catch((err) => {
        this.addNotification('danger', err.reason)
      })
    },
    confirmPushAllAct () {
      this.startLoading()
      this.creativePushBulkAssociations({hash_id: this.confirmId}).then((res) => {
        this.getCreatives(this.$route.params.id).then(() => {
          this.addNotification('success', res.reason)
          this.backFromAnything()
          this.finishLoading()
        })
      })
    },
    pushAct (id) {
      this.backFromAnything()
      this.modalHeadVal = 'Push Creative To User'
      this.isPushingSingle = true
      this.form.hash_id = id
    },
    pushAllAct () {
      this.backFromAnything()
      this.modalHeadVal = 'Push Creatives To User'
      this.isPushingAll = true
    },
    confirmDelete () {
      this.startLoading()
      this.deleteCreative(this.selectedCreative).then(() => {
        this.getCreatives(this.$route.params.id).then(() => {
          this.addNotification('success', `Creative successfully deleted.`)
          this.backFromAnything()
          if (this.creative.childs.length < 1) {
            this.close()
          }
          this.finishLoading()
        }, error => {
          this.addNotification('danger', error)
          this.backFromAnything()
          this.finishLoading()
        })
      }, error => {
        this.addNotification('danger', error)
        this.backFromAnything()
        this.finishLoading()
      })
    },
    confirm () {
      if (!this.creative.childs) {
        return
      }
      this.creative.childs[0].fields.forEach((field) => {
        if (field.is_editable) {
          this.form.editable_fields.push(field.name)
        }
      })
      this.form.users = [...this.userss, ...this.localUsers]
      this.startLoading()
      this.editAssociateCreative(this.form).then(res => {
        this.getCreatives(this.creative.campaign.hash_id).then(() => {
          this.finishLoading()
          this.backFromAnything()
          // this.close()
        })
      })
    },
    backFromAnything () {
      this.form.editable_fields = []
      this.userss = []
      this.localUsers = []
      this.selectedCreative = null
      this.modalHeadVal = 'Edit Associations'
      this.isDeleting = false
      this.isEditingFields = false
      this.isPushingSingle = false
      this.isPushingAll = false
      this.isAddingAssignee = false
      this.isAcceptingApproval = false
    },
    deleteCreativeAct (id) {
      this.modalHeadVal = 'Delete Association'
      this.isDeleting = true
      this.selectedCreative = id
    },
    approveDownloadsAct (id) {
      this.backFromAnything()
      this.modalHeadVal = 'Approve Downloads?'
      this.isAcceptingApproval = true
      this.selectedCreative = id
    },
    confirmApprove () {
      this.startLoading()
      this.approveCreativeDownloadApproval({
        hash_id: this.selectedCreative
      }).then(() => {
        this.getCreatives(this.creative.campaign.hash_id).then(() => {
          this.backFromAnything()
          this.finishLoading()
          // this.close()
        })
      })
    },
    editFields (id) {
      this.form.hash_id = id
      this.backFromAnything()
      this.isEditingFields = true
    },
    addAssignee (id) {
      this.form.hash_id = id
      this.backFromAnything()
      // this.modalHeadVal = 'Add New Assignees'
      this.isAddingAssignee = true
    },
    getUsers () {
      return this.getUsersToBeAssociated.filter((user) => user.role !== 6)
    },
    getLocalUsers () {
      return this.getUsersToBeAssociated.filter((user) => user.role === 6)
    }
  }
}
</script>

<style lang="scss">
.center {
  display: flex;
  margin: auto;
  width: 50%;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-edit-creative-associate.vue